import React from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import Label from "./Label";

const Textarea = ({
    value,
    validation = (val) => true,
    required = false,
    errorMessage = null,
    onChange = (val) => {},
    rows = 5,
    label = null,
    classNames = '',
    textCls = 'sm:test-sm',
    marginCls = 'mt-2 mb-1',
    paddingCls = 'px-2 py-2',
    hideBottomMargin = false,
    disabled = false,
    ...rest
}) => {
  const showError = errorMessage && (!validation(value) || (required && !value));

  return <div className={`w-full relative ${!hideBottomMargin ? "mb-5" : ""}`}>
    {label && <Label>{label}</Label>}
    <textarea
      rows={rows}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`${marginCls} font-normal ${paddingCls} border shadow-sm focus:ring-am-500 text-black-500 disabled:text-black-300 focus:border-black-500 block w-full ${textCls} border-gray-300 ${disabled ? "opacity-50 cursor-not-allowed bg-gray-200" : ""} ${!showError && !hideBottomMargin ? 'mb-5' : ''} ${classNames}`}
      {...(required ? {required: "required"} : {})}
      {...rest}
    />
    {
      showError && <>
        <div className="absolute inset-y-0 right-0 pr-3 mb-5 flex items-center pointer-events-none">
          <ExclamationCircleIcon
            className="h-5 w-5 text-red-500"
            aria-hidden="true"
          />
        </div>
        <p className="mt-1 text-xs text-red-600">
          {errorMessage}
        </p>
      </>
    }
  </div>
}

export default Textarea;
